import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { ButtonRow } from '@components/styles';
import { Button } from 'primereact/button';
import HorizontalFieldValue from '@components/obsolete/HorizontalFieldValue.tsx';
import SectionPanel from '@components/framework/panels/SectionPanel.tsx';
import { Form as FormApi, proxiedPropertiesOf } from '@hooks/useForm/useForm';
import { Form } from '@components/pages/admin/companies/adminCompanyDetailForm.ts';
import { EnableFeature } from '@components/pages/admin/companies/AdminCompanyDetailInputs.tsx';
import SvgList from '@icons/list.svg?react';

interface ComponentProps {
  form: FormApi<Form>;
  onSave: () => void;
  saving: boolean;
}

const names = proxiedPropertiesOf<Form>();

const FeaturesSection: React.FC<ComponentProps> = ({ form, onSave, saving }) => {
  const { tr } = useTranslationLgs();

  return (
    <SectionPanel
      icon={<SvgList className={'w-6 h-6'} />}
      iconColor={'var(--content-tertiary)'}
      heading={tr('adminCompanyDetail.sectionFeatures', 'Features')}
      dataTestId={'admin-company-section-features'}>
        <HorizontalFieldValue label={tr('adminCompanyDetail.features', 'Features')} value={<EnableFeature value={form.values.features} onChange={v => form.setFieldValue(names.features, v)} />} />
        <ButtonRow>
          <Button label={tr('generic.save', 'Save')} onClick={onSave} loading={saving} disabled={saving} />
        </ButtonRow>
    </SectionPanel>
  );
};

export default FeaturesSection;
